import { Box, HStack, Text } from '@chakra-ui/react';
import type { FC, ReactNode } from 'react';
import { EMAIL_COMPOSER_ROW_LABEL_WIDTH } from './email-composer-layout';

interface EmailComposerRecipientLabelRowProps {
  label: string;
  /** Who the email goes to, as one line (e.g. a recipient count). */
  value: string;
  /** Optional discreet line stacked under the value. */
  caption?: ReactNode;
}

/**
 * Recipient row of the bulk composers: a fixed-width label beside a summary of
 * the recipients. Label and value share one flex row so the caption, stacked
 * under the value, keeps the value's exact left edge (a plain padding-left
 * would miss the row gap).
 */
const EmailComposerRecipientLabelRow: FC<EmailComposerRecipientLabelRowProps> = ({
  label,
  value,
  caption,
}) => (
  <HStack minW={0} gap={3} align="flex-start">
    <Text
      fontSize="sm"
      color="fg.muted"
      w={EMAIL_COMPOSER_ROW_LABEL_WIDTH}
      flexShrink={0}
      lineHeight="28px"
    >
      {label}
    </Text>
    <Box minW={0}>
      <Text fontSize="sm" fontWeight="medium" truncate lineHeight="28px">
        {value}
      </Text>
      {caption ?? null}
    </Box>
  </HStack>
);

export default EmailComposerRecipientLabelRow;
